<template id="dialogPoiDetailsTmpl">
    <div>
        <v-dialog v-model="dlgPoiDetailsIsOpen" persistent max-width="500px">
            <v-card>

                <v-card-title v-if="isEmptyObj(selectedPoiObj) == false">
                    {{selectedPoiObj.poi_name}}
                </v-card-title>

                <v-card-text  v-if="isEmptyObj(selectedPoiObj) == false">
                    <v-row no-gutters>
                        <v-col cols="12" class="title font-weight-black">
                            {{selectedPoiObj.thing_0_value}}
                        </v-col>
                    </v-row>
                    <div v-if="!this.isEmptyObj(selectedPoiObj.thing_0_value) && selectedPoiObj.thing_0_value != 'No data found'">
                        <v-row no-gutters >
                            <v-col cols="12">
                                <strong>{{selectedPoiObj.thing_0_timestamp}}</strong>
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-if="!this.isEmptyObj(selectedPoiObj.alert) && (selectedPoiObj.alert == 1 || selectedPoiObj.alert == '1')">
                            <v-col cols="12" style="color: #ff0000; font-weight: bold;">
                            <v-icon class="alertIcon mr-2">mdi-alert</v-icon>
                                {{ $t('lbl.alertMsg')}}
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-row no-gutters>

                        <v-col cols="12" md="4" class="pa-1"
                            v-if="isEmptyObj(selectedPoiObj) == false"
                        >
                            <v-btn class="button-main ma-1" style="width: 100%"
                                v-on:click="openPoiChart(selectedPoiObj.poi_id)"
                            ><v-icon left dark>bar_chart</v-icon>{{ $t('btn.poiThingStats')}}</v-btn>
                        </v-col>

                        <v-col cols="12" md="4" class="pa-1"
                            v-if="isEmptyObj(selectedPoiObj) == false && isEmptyString(selectedPoiObj.thing_0_link) == false"
                        >
                            <v-btn class="button-main ma-1" style="width: 100%"
                                v-on:click="openPoiThingLink(selectedPoiObj.thing_0_link)"
                            ><v-icon left dark>list_alt</v-icon>{{ $t('btn.poiThingLink')}}</v-btn>
                        </v-col> 

                        <v-col cols="12" md="4" class="pa-1">
                             <v-btn class="button-main ma-1" style="width: 100%" v-on:click="closeDlgPoiDetails()">
                             <v-icon left dark>close</v-icon>{{ $t('btn.closeDialog')}}
                             </v-btn>
                        </v-col>   
                    </v-row>
                  
                </v-card-actions>

            </v-card>
        </v-dialog>

        <dlg-thing-stats ref="dlgThingStats" :orgid="orgid" :siteid="siteid" :mapDetailObj="mapDetailObj"></dlg-thing-stats>
    </div>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';
import ctDialogThingStats from "@/components/commons/ctDialogThingStats.vue";

export default {
    i18n,
    data: () => ({
        dlgPoiDetailsIsOpen: false,
        delayedDlgPoiDetailsIsOpen: false,
        selectedPoiObj: null,
    }),
    props: ['orgid', 'siteid', 'mapDetailObj'],
    components: {
        "dlg-thing-stats":ctDialogThingStats,
    },
    methods: {
        openDlgPoiDetails(poiObj) 
        {
            this.selectedPoiObj = poiObj;
            this.dlgPoiDetailsIsOpen = true;
            this.delayedDlgPoiDetailsIsOpen = true;
        },  
        closeDlgPoiDetails() 
        {
            this.dlgPoiDetailsIsOpen = false;
            this.selectedPoiObj = null;
            // Resetta la nuova variabile dopo 0.5 secondi
            setTimeout(() => {
                this.delayedDlgPoiDetailsIsOpen = false;
            }, 500);
        },
        openPoiThingLink(link)
        {
            window.open(link, '_blank');
        },
        openPoiChart(poi_id)
        {
            this.$refs.dlgThingStats.openThingStats(poi_id);
        },
    },  
}
</script>     